import { render, staticRenderFns } from "./TextInModal.vue?vue&type=template&id=7ae5d3a2&scoped=true"
import script from "./TextInModal.vue?vue&type=script&lang=js"
export * from "./TextInModal.vue?vue&type=script&lang=js"
import style0 from "./TextInModal.vue?vue&type=style&index=0&id=7ae5d3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae5d3a2",
  null
  
)

export default component.exports